angular.module('webremote.dashboard').controller('widget_transmissionStatistics', 
function ($scope, $log) {

    // TODO

});
